const appId = 'wider-web';
const appName = 'riderapp';
const clientId = 'f3b17ba3-7d5d-4c30-ba63-5fe137acb243';
const clientSecret = 'pass';
const locales = ['en', 'es'];

const baseUrl = 'https://mobility-app-west.transitsherpa.com/rider/graphql/';
const scope = 'cascades-east-prod';
const processor = 'braintree';
const googleAnalyticsId = 'DISABLED';
const reCaptchaSiteKey = '6LdKPyYUAAAAAOvis88qcmnaazGowUgPMuTCwMT6';
const communicationPref = false;
const dualAuth = false;
const promotions = false;
const autoReplenish = false;
const ONE_TIME_PAYMENT_DURATION = 15 * 60 * 1000;
const oneTimePayment = false;
const riderTypeSelect = false;
const migration = false;
const fareCapping = true;
const registrationFields = {
  name: 'required',
  mobile: 'required',
  address: false,
  city: false,
  state: false,
  zipCode: false
};

export {
  appId,
  appName,
  clientId,
  clientSecret,
  locales,
  baseUrl,
  scope,
  processor,
  googleAnalyticsId,
  reCaptchaSiteKey,
  communicationPref,
  dualAuth,
  promotions,
  autoReplenish,
  ONE_TIME_PAYMENT_DURATION,
  oneTimePayment,
  riderTypeSelect,
  migration,
  fareCapping,
  registrationFields
};
